<template>
    <div class="header-top">
      <div class="header-top-content">
        <div class="header-top-subtitle">
          {{subtitle}}
        </div>
        <h2 class="header-top-title">
          {{title}}
        </h2>
      </div>
    </div>
</template>

<script>
import "./quote.scss";
import { mapGetters } from "vuex";

export default {
    name: "Quote",

    computed: {
      ...mapGetters(['title','subtitle'])
    }
}
</script>